// extracted by mini-css-extract-plugin
module.exports = {"root":"MonthRangeSwitch_root__Ns9ls","range":"MonthRangeSwitch_range__3Lq7K","disabled":"MonthRangeSwitch_disabled__2h4wu"};